import React, { useEffect, useState } from 'react'
import { useActivities, useProcessTemplate, useRoutes } from './store'
import FlowEditor from './components/FlowEditor'
import { getEdgesFromRoutes, getNodesFromActivities } from './utils/transformer'
import { useParams } from 'react-router-dom'
import { workflowService } from '../../../services/admin/workflow'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { processTemplateService } from '../../../services/processTemplateService'
import CreateEditRouteDialog from './components/CreateEditRouteDialog'
import { Box, Button, FormControl, MenuItem, Select, Typography } from '@mui/material'
import CreateActivityTemplateDialog from './components/CreateActivityTemplateDialog'

const Workflow = () => {
  const processTemplateId = useParams().process_template_id

  const { user } = useAuthContext()
  const activities = useActivities((state) => state.activities)
  const setActivities = useActivities((state) => state.setActivities)
  const routes = useRoutes((state) => state.routes)
  const setRoutes = useRoutes((state) => state.setRoutes)
  const processTemplate = useProcessTemplate((state) => state.processTemplate)
  const setProcessTemplate = useProcessTemplate((state) => state.setProcessTemplate)
  const [showCreateActivityDialog, setShowCreateActivityDialog] = useState(false)
  const [selectActivity, setSelectActivity] = useState('All Activities')

  useEffect(() => {
    ;(async () => {
      if (user) {
        // get process details
        const processTemplate = (
          await processTemplateService.getProcessTemplate(user, processTemplateId)
        ).data[0]
        setProcessTemplate(processTemplate)

        // get all activities related process
        const activities = await workflowService.getActivities(user, processTemplateId)
        setActivities(activities)

        // get all routes related all activities in current process
        const routes = await workflowService.getRoutes(user, processTemplateId)
        setRoutes(routes)
      }
    })()
  }, [processTemplateId, user])

  const createActivity = () => {
    setShowCreateActivityDialog(true)
  }

  return (
    <Box>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: '10px',
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Typography variant="h5" fontWeight={'bold'}>
            {processTemplate?.process_template_name}
          </Typography>
        </Box>

        <Box style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: 2 }}>
          <FormControl sx={{ width: 150 }} size="small">
            <Select
              onChange={(event) => setSelectActivity(event.target.value)}
              value={selectActivity}
            >
              <MenuItem value="All Activities">All Activities </MenuItem>
              {activities.map((activity) => (
                <MenuItem key={activity.id} value={activity.activity_template_name}>
                  {activity.activity_template_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            color="primary"
            variant="contained"
            form="data-entry-form"
            style={{ height: 30 }}
            onClick={createActivity}
          >
            Add Activity
          </Button>
        </Box>
      </Box>

      <Box style={{ border: '1px solid gray', margin: 0, marginTop: 16, borderRadius: 4 }}>
        <FlowEditor
          initialNodes={getNodesFromActivities(activities)}
          initialEdges={getEdgesFromRoutes(routes, activities)}
          selectActivity={selectActivity}
        />
      </Box>
      <CreateEditRouteDialog processTemplateId={processTemplateId} />
      <CreateActivityTemplateDialog
        show={showCreateActivityDialog}
        setShow={setShowCreateActivityDialog}
        processTemplateId={processTemplateId}
      />
    </Box>
  )
}

export default Workflow
